export default function onlyNumbers(text: string) {
  // Verifica se o primeiro caractere é "-" e remove todos os caracteres não numéricos, exceto o "-" e "."
  if (text?.startsWith('-')) {
    return Number('-' + text.slice(1).replace(/[^\d.]/g, ''));
  } else {
    return Number(text.replace(/[^\d.]/g, ''));
  }
}
